import { Component } from '@angular/core';

import { DashboardNutritionPage } from '../dashboard/nutrition/dashboard-nutrition';
import { FoodInventoryPage } from '../food/food-inventory';
import { ExerciseListPage } from '../exercises/exercise-list';
import { MemoPage } from '../memo/memo';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tabHomeRoot = DashboardNutritionPage;
  tabFoodRoot = FoodInventoryPage;
  tabExerciseRoot = ExerciseListPage;
  tabMemoRoot = MemoPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts